import { useState, useContext, useEffect } from "react";
import { FaGlobe, FaInfo, FaPlusCircle, FaPrint, FaChartLine, FaCalculator, FaUndo, FaCog, FaArrowLeft, FaSave } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import DropDown from "components/ui/controls/drop-down/drop-down";
import TextField from "components/ui/controls/text-field/text-field";
import Hover from "components/ui/controls/hover/hover";
import ParamStrategiePERModal from "./parametrage strategie PER";
import { GetCalculStrategiePER } from "components/app/Api/ApiSimulateur";
import _ from "lodash";
import { SyntheseStrategiePER } from "components/app/Api/Rapport/ApiRapport";
import { applyFormat } from "components/ui/ui-helpers";
import "../../AuditComplet/ContexteFiscal/ContexteFiscal.css";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { useStudyManagementHandlers } from "pages/studyManagementHandler";

// Composant pour un graphique en barres empilées
const StackedBarChart = ({ title, data, colors }) => {
  if (!data || data.length === 0) return null;

  // Calcul de la valeur maximale pour normaliser les hauteurs
  const maxValue = Math.max(...data.map((item) => item.value1 || 0));

  // Calcul des valeurs pour l'échelle
  const scaleSteps = 5;
  const stepValue = maxValue / scaleSteps;

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e5e7eb",
        marginBottom: "20px",
        height: "400px",
      }}
    >
      <h3
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#1f2937",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        {title}
      </h3>

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          height: "300px",
          gap: "15px",
        }}
      >
        {/* Échelle verticale */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "250px",
            marginRight: "10px",
            marginBottom: "38px",
          }}
        >
          {Array.from({ length: scaleSteps + 1 }, (_, index) => {
            const value = maxValue - index * stepValue;
            return (
              <div
                key={index}
                style={{
                  fontSize: "10px",
                  color: "#6b7280",
                  textAlign: "right",
                  minWidth: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                {applyFormat(value, "uint", { thousands: " ", unit: " €" })}
              </div>
            );
          })}
        </div>

        {/* Container des barres */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "space-around",
            height: "250px",
            gap: "15px",
            flex: 1,
            marginTop: "20px",
          }}
        >
          {data.map((item, index) => {
            const value = item.value1 || 0;
            const maxHeight = 250;
            const barHeight = maxValue > 0 ? (value / maxValue) * maxHeight : 10;

            let backgroundColor = "linear-gradient(135deg, rgb(59, 130, 246) 0%, rgb(29, 78, 216) 100%)";
            if (item.category === "Economie d'impôt") {
              backgroundColor = "linear-gradient(135deg, rgb(5, 150, 105) 0%, rgb(4, 120, 87) 100%)";
            } else if (item.category === "Effort réel d'épargne") {
              backgroundColor = "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)";
            }
            return (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flex: 1,
                  maxWidth: "120px",
                }}
              >
                {/* Barre */}
                <div
                  style={{
                    width: "100px",
                    height: `${barHeight}px`,
                    background: backgroundColor,
                    borderRadius: "8px 8px 4px 4px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    cursor: "pointer",
                    transition: "transform 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "10px",
                    fontWeight: "600",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)";
                  }}
                >
                  {applyFormat(value, "uint", { thousands: " ", unit: " €" })}
                </div>

                {/* Label sous la barre */}
                <div
                  style={{
                    fontSize: "11px",
                    fontWeight: "500",
                    color: "#6b7280",
                    textAlign: "center",
                    marginTop: "8px",
                    lineHeight: "1.2",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {item.category}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const StrategiePER = (props) => {
  let { clientConjoint } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalStrategie, setModalStrategie] = useState(false);
  const [results, setResults] = useState({});
  const [disponible163Calcule, setDisponible163Calcule] = useState(0);
  const { handleSave, handleGoToAudits } = useStudyManagementHandlers(props);
  const dt = new Date();
  const yearM1 = dt.getFullYear() - 1;
  const yearM2 = dt.getFullYear() - 2;
  const yearM3 = dt.getFullYear() - 3;
  const year = dt.getFullYear();

  const CalculDisponible = () => {
    if (context.state.StrategiePERCadreFiscal === "Madelin") {
      GetCalculStrategiePER(context.state, "", "StrategiePERCalculDisponibleMadelin").then((DisponibleMadelin) => {
        context.handleValueChange("StrategiePERDisponibleFiscal", DisponibleMadelin);
      });
    } else {
      GetCalculStrategiePER(context.state, "", "StrategiePERCalculDisponiblePER163").then((Disponible163) => {
        let Values = _.cloneDeep(context.state.StrategiePERDisponibleTabPlafond163);

        if (year in Values) {
          Values[year]["Client"] = Disponible163.Dirigeant;
          setDisponible163Calcule(Disponible163.Dirigeant);
          context.handleValueChange("StrategiePERDisponibleTabPlafond163", Values);
          context.handleValueChange("StrategiePERDisponibleFiscal", Disponible163.Total);
        }
      });
    }
  };

  const CalculCapital = () => {
    GetCalculStrategiePER(context.state, "", "StrategiePERCalculStrategie").then((results) => {
      setResults(results);
      context.handleValueChange("StrategiePERResultat", results);
    });
  };

  useEffect(() => {
    let InitValues = _.cloneDeep(context.state.StrategiePERDisponibleTabPlafond163);
    if (!(year in InitValues)) {
      InitValues[year] = { Client: 0, SetClient: false, Conjoint: 0, SetConjoint: true };
    }
    if (!(yearM1 in InitValues)) {
      InitValues[yearM1] = { Client: 0, Conjoint: 0 };
    }
    if (!(yearM2 in InitValues)) {
      InitValues[yearM2] = { Client: 0, Conjoint: 0 };
    }
    if (!(yearM3 in InitValues)) {
      InitValues[yearM3] = { Client: 0, Conjoint: 0 };
    }
    context.handleValueChange("StrategiePERDisponibleTabPlafond163", InitValues);
    CalculCapital();
  }, []);

  useEffect(() => {
    CalculDisponible();
  }, [context.state.StrategiePERCadreFiscal, context.state.StrategiePERRevenuNetActivite, context.state.StrategiePERContratVersementInitial]);
  return (
    <>
      <Column fill>
        <Row style={{ alignItems: "stretch" }}>
          <Column fill style={{ maxWidth: "820px", display: "flex", flexDirection: "column" }}>
            <CardBox className="blockRoundedForce" bpad style={{ flex: 1, padding: "25px", height: "100%" }}>
              <div className="revenuspro-container" style={{ marginBottom: "20px", height: "100%", paddingLeft: "0px" }}>
                {/* Titre au-dessus du tableau */}
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaChartLine />
                  </div>
                  <h1 className="dossier-header-title">Stratégie PER {context.state.Prenom}</h1>
                </div>

                {/* Conteneur des boutons d'actions */}
                <div style={{ marginBottom: "20px" }}>
                  <div style={{ display: "flex", gap: "12px", justifyContent: "flex-start" }}>
                    <ActionButton
                      onClick={() => {
                        setModalStrategie(true);
                      }}
                      icon={FaPlusCircle}
                      title="Ajouter  une stratégie"
                      subtitle="Mise en place d'un PER"
                      colors={{
                        primary: "#667eea",
                        secondary: "#5a6fd8",
                        shadow: "rgba(102, 126, 234, 0.4)",
                        shadowHover: "rgba(102, 126, 234, 0.6)",
                      }}
                      decorativeIcon={{ type: "document" }}
                      style={{ minWidth: "235px" }}
                    />
                  </div>
                </div>

                {/* Effort d'épargne */}
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaChartLine />
                  </div>
                  <h1 className="dossier-header-title">Effort réel d'épargne</h1>
                </div>
                <div style={{ marginBottom: "20px" }}>
                  <StackedBarChart title="Effort réel d'épargne" data={results?.enActivite?.graphEffortEpargne || []} colors={["#3b82f6"]} />
                </div>
              </div>
            </CardBox>
          </Column>
          <Column fill style={{ maxWidth: "720px", display: "flex", flexDirection: "column", height: "100%" }}>
            <CardBox bpad className=" blockRoundedForce" style={{ padding: "20px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <Column fill style={{ padding: "10px 5px" }}>
                {/* Bouton d'impression */}
                <div style={{ gap: "12px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <ActionButton
                    onClick={() => {
                      SyntheseStrategiePER(context.state, results);
                    }}
                    icon={FaPrint}
                    title="Impression"
                    subtitle="Editer un Word"
                    colors={{
                      primary: "#11998e",
                      secondary: "#0d7377",
                      shadow: "rgba(17, 153, 142, 0.4)",
                      shadowHover: "rgba(17, 153, 142, 0.6)",
                    }}
                    decorativeIcon={{ type: "document" }}
                  />
                  <ActionButton
                    onClick={() => {
                      handleSave();
                    }}
                    icon={FaSave}
                    title="Sauvegarder"
                    subtitle="Sauvegarder l'étude"
                    colors={{
                      primary: "rgb(124, 58, 237)",
                      secondary: "rgb(109, 40, 217)",
                      shadow: "rgba(124, 58, 237, 0.4)",
                      shadowHover: "rgba(124, 58, 237, 0.6)",
                      background: "linear-gradient(135deg, rgb(124, 58, 237) 0%, rgb(109, 40, 217) 100%)",
                    }}
                    decorativeIcon={{ type: "save" }}
                  />
                  <ActionButton
                    onClick={() => {
                      handleGoToAudits();
                    }}
                    icon={FaArrowLeft}
                    title="Quitter"
                    subtitle="Revenir aux audits"
                    colors={{
                      primary: "#e57373",
                      secondary: "#c62828",
                      shadow: "rgba(229, 115, 115, 0.4)",
                      shadowHover: "rgba(229, 115, 115, 0.6)",
                    }}
                    decorativeIcon={{ type: "previous" }}
                  />
                </div>
              </Column>
            </CardBox>
            <CardBox bpad className="blockRoundedForce" style={{ padding: "25px", flex: 1 }}>
              <div className="revenuspro-container" style={{ marginBottom: "20px", paddingLeft: "0px" }}>
                {/* Titre */}
                <div className="dossier-header" style={{ marginBottom: "15px" }}>
                  <div className="dossier-header-icon">
                    <FaCalculator />
                  </div>
                  <h1 className="dossier-header-title">Comparatif rente et capital</h1>
                </div>

                {/* Header des colonnes */}
                <div className="header-card">
                  <div className="category-column" style={{ textAlign: "left", flex: 2 }}>
                    Type
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    Sortie en rente
                  </div>
                  <div className="value-column" style={{ textAlign: "center" }}>
                    Sortie en capital
                  </div>
                </div>

                {/* Conteneur des cartes de contenu */}
                <div className="card-list-container">
                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">🏛️</div>
                      Régimes obligatoires
                    </div>
                    <div className="value-column">
                      <TextField value={results?.ro?.retraiteNetteApresImpot || 0} disabled dataType="uint" format={{ thousands: " ", unit: " €" }} />
                    </div>
                    <div className="value-column">
                      <TextField value={results?.ro?.retraiteNetteApresImpot || 0} disabled dataType="uint" format={{ thousands: " ", unit: " €" }} />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📊</div>
                      PER individuel
                    </div>
                    <div className="value-column">
                      <TextField value={results?.sortie?.rente?.renteNetteApresImpot || 0} disabled dataType="uint" format={{ thousands: " ", unit: " €" }} />
                    </div>
                    <div className="value-column">
                      <TextField value={results?.sortie?.capital?.capitalNetApresImpot || 0} disabled dataType="uint" format={{ thousands: " ", unit: " €" }} />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">💰</div>
                      Retraite nette totale annuelle
                    </div>
                    <div className="value-column">
                      <TextField
                        value={(results?.ro?.retraiteNetteApresImpot || 0) + (results?.sortie?.rente?.renteNetteApresImpot || 0)}
                        disabled
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                    <div className="value-column">
                      <TextField
                        value={(results?.ro?.retraiteNetteApresImpot || 0) + (results?.sortie?.capital?.capitalNetApresImpot || 0)}
                        disabled
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📅</div>
                      Retraite nette totale mensuelle
                    </div>
                    <div className="value-column">
                      <TextField
                        value={(results?.ro?.retraiteNetteApresImpot || 0) / 12 + (results?.sortie?.rente?.renteNetteApresImpot || 0) / 12}
                        disabled
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                    <div className="value-column">
                      <TextField
                        value={(results?.ro?.retraiteNetteApresImpot || 0) / 12 + (results?.sortie?.capital?.capitalNetApresImpot || 0) / 12}
                        disabled
                        dataType="uint"
                        format={{ thousands: " ", unit: " €" }}
                      />
                    </div>
                  </div>

                  <div className="card">
                    <div className="category-column" style={{ flex: 2 }}>
                      <div className="titre-icone">📈</div>
                      Taux de remplacement
                    </div>
                    <div className="value-column">
                      <TextField
                        value={
                          results?.enActivite?.remNetteApresImpot === 0
                            ? 0
                            : (((results?.ro?.retraiteNetteApresImpot || 0) + (results?.sortie?.rente?.renteNetteApresImpot || 0)) / (results?.enActivite?.remNetteApresImpot || 1)) * 100
                        }
                        disabled
                        dataType="uint"
                        format={{ thousands: " ", unit: " %" }}
                      />
                    </div>
                    <div className="value-column">
                      <TextField
                        value={
                          results?.enActivite?.remNetteApresImpot === 0
                            ? 0
                            : (((results?.ro?.retraiteNetteApresImpot || 0) + (results?.sortie?.capital?.capitalNetApresImpot || 0)) / (results?.enActivite?.remNetteApresImpot || 1)) * 100
                        }
                        disabled
                        dataType="uint"
                        format={{ thousands: " ", unit: " %" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </CardBox>
          </Column>
        </Row>
      </Column>

      <Modal
        width="80%"
        height="82%"
        title="Stratégie PER"
        icon={<FaGlobe />}
        visible={modalStrategie}
        onClose={() => {
          setModalStrategie(false);
        }}
      >
        <ParamStrategiePERModal
          Results={results}
          ClientConjoint={clientConjoint}
          CalculDisponible={CalculDisponible}
          Disponible163Calcule={disponible163Calcule}
          CalculCapital={CalculCapital}
          visible={modalStrategie}
          onClose={() => {
            setModalStrategie(false);
          }}
        />
      </Modal>
    </>
  );
};

export default StrategiePER;
